module.exports = __webpack_public_path__ + "static/twt_trailer_thumb-8f191b96c3eca451c2a54398d5633074.jpg";